import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation, useNavigate } from "react-router-dom";

// Shown only when this page was reached from the /search facet page —
// HitLink and the CAMap click tag that navigation with state.fromSearch.
// History state survives refresh and back/forward; a direct link has none.
export const BackToSearchButton = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  if (!(state as any)?.fromSearch) return null;
  return (
    <button
      onClick={() => navigate(-1)}
      className="absolute top-2 right-10 px-2.5 py-1 rounded-full text-sm text-white bg-black/30 hover:text-dark hover:bg-white"
    >
      <FontAwesomeIcon icon={faArrowLeft} className="w-3 h-3 pr-1" />
      Terug naar zoeken
    </button>
  );
};
